import { useCurrentlyPlayingContext } from "../context/CurrentlyPlayingContext";

const useCurrentlyPlayingSong = () => useCurrentlyPlayingContext();

export default useCurrentlyPlayingSong;
